import React from 'react';
import PropTypes from 'prop-types';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import { toast } from 'react-toastify';
import IEdit from '@meronex/icons/fi/FiEdit2';
import TopHeader from '../../../../views/components/TopHeader';

import storesMng from '../../../api/storesMng';

function EditTransactionDialog(props) {
  const { open, onClose, transaction, onSave } = props;

  const [note, setNote] = React.useState('');
  const [invoiceNumber, setInvoiceNumber] = React.useState('');
  const [supplier, setSupplier] = React.useState('');
  const [project, setProject] = React.useState('');
  const [saving, setSaving] = React.useState(false);

  React.useEffect(() => {
    if (transaction) {
      setNote(transaction.note || '');
      setInvoiceNumber(transaction.invoiceNumber || '');
      setSupplier(transaction.supplier || '');
      setProject(transaction.project || '');
    }
  }, [transaction]);

  if (!transaction) return null;

  const handleSave = async () => {
    setSaving(true);
    try {
      await storesMng.updateTransactionMetadata({
        transactionId: transaction._id,
        note,
        invoiceNumber,
        supplier,
        project,
      });
      toast.success('Transaction updated', { autoClose: 900 });
      if (onSave) onSave({ note, invoiceNumber, supplier, project });
      onClose();
    } catch (e) {
      console.error(e);
      toast.error(e.reason || 'Failed to update transaction');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <TopHeader
          title={'Edit Transaction'}
          onClose={onClose}
          icon={<IEdit size={18} />}
        />
      </DialogTitle>
      <DialogContent>
        <TextField
          label="Note"
          fullWidth
          multiline
          maxRows={4}
          variant="outlined"
          value={note}
          onChange={(e) => setNote(e.target.value)}
          style={{ marginBottom: 16 }}
        />
        <TextField
          label="Invoice Number"
          fullWidth
          variant="outlined"
          value={invoiceNumber}
          onChange={(e) => setInvoiceNumber(e.target.value)}
          style={{ marginBottom: 16 }}
        />
        <TextField
          label="Supplier"
          fullWidth
          variant="outlined"
          value={supplier}
          onChange={(e) => setSupplier(e.target.value)}
          style={{ marginBottom: 16 }}
        />
        <TextField
          label="Project"
          fullWidth
          variant="outlined"
          value={project}
          onChange={(e) => setProject(e.target.value)}
          placeholder="e.g. Bathroom Renovation Block B"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Cancel
        </Button>
        <Button
          onClick={handleSave}
          color="primary"
          variant="contained"
          disabled={saving}
        >
          {saving ? 'Saving...' : 'Save'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

EditTransactionDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  transaction: PropTypes.object,
  onSave: PropTypes.func,
};

export default EditTransactionDialog;
